module.exports = __webpack_public_path__ + "headline.png?894a38bcd66ac6a6aed90563b39b0ed5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headline.png
// module id = 185
// module chunks = 0